import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const CACHE_KEY = "public_meta";

const FALLBACK = {
  platform_name: "",
  logo: "",
  favicon: "",
  needs_setup: false,
  public: { login: {}, landing: {} },
};

function readCache() {
  try {
    const raw = window.localStorage.getItem(CACHE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

/**
 * Public branding for the sign-in and landing pages.
 *
 * Starts from what was seen last time, so the name doesn't briefly show the
 * default and then correct itself on every refresh. Still refetches in the
 * background, so a change made in settings appears on the next load.
 */
/** Swap the browser tab icon for the uploaded one. */
function applyFavicon(href) {
  if (!href) return;
  let link = document.querySelector("link[rel='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.href = href;
}

export function usePublicMeta() {
  const [meta, setMeta] = useState(() => {
    const cached = readCache();
    // Applied from the cache first, so the tab doesn't flash the default icon.
    if (cached?.favicon) applyFavicon(cached.favicon);
    return cached || FALLBACK;
  });

  useEffect(() => {
    let cancelled = false;
    api
      .get("/meta")
      .then(({ data }) => {
        if (cancelled) return;
        setMeta(data);
        applyFavicon(data.favicon);
        try {
          window.localStorage.setItem(CACHE_KEY, JSON.stringify(data));
        } catch {
          /* private browsing — it just won't be remembered */
        }
      })
      .catch(() => {
        /* keep whatever we have */
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return meta;
}
